import store from '@/store/store'

/**
 * Retrieves a list of POP colors for a user based on the specified location and status.
 *
 * @param {string} location - The location key to match against user TBE locations.
 * @param {string|string[]} status - The status or array of statuses to filter locations.
 * @returns {string[]} An array of POP color strings associated with the user for the given location and status.
 */
const getUserPOPColors = (location, status) => {
  const statusArray = Array.isArray(status) ? status : [status]

  let tbes = (store.state.user.user && store.state.user.user.userTBEs) || []
  const tbeAdmin = tbes.some((tbe) => tbe.territory === 'ADMIN' && tbe.businessEntity === 'ADMIN')

  if (tbeAdmin) tbes = store.state.options.data?.tbe || tbes
  const popColorLookup = { AST: true }

  for (const tbe of tbes) {
    for (const loc of tbe.locations) {
      const split = loc.key.split('_')

      // Check if any status element is included in split[1]
      const statusMatch = statusArray.some((s) => split[1].includes(s))

      if (split[0] === location && statusMatch) {
        for (const color of tbe.colorFilters.POP) {
          popColorLookup[color] = true
        }
      }
    }
  }
  const popColors = []
  for (const color of Object.keys(popColorLookup)) {
    popColors.push(color)
  }

  return popColors
}

export { getUserPOPColors }
